export default __webpack_public_path__ + "static/media/docIcon.dbbaf012.svg";